/* (ignored) */


/*****************
 ** WEBPACK FOOTER
 ** vertx (ignored)
 ** module id = 10
 ** module chunks = 0
 **/